import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class TrackerService {
  constructor(private http: HttpClientService) {}

  public trackDownloadOcrCsv(): Observable<any> {
    return this.http
      .post("/api/tracker/download_ocr_csv", {})
      .pipe(tap((_) => console.log("TrackerService.trackDownloadOcrCsv: Ok.")));
  }

  public priorityQuotes(person_id): Observable<any> {
    const options = {
      metadata: { person_id },
    };
    return this.http
      .post("/api/tracker/priority_quotes", options)
      .pipe(tap((_) => console.log("TrackerService.priorityQuotes: Ok.")));
  }
}
